<template>
    <div>
        <div class="card so-card">
            <div class="so-header">
                <TitleButton btnTitle="List" :showBtn="true" :showAddNew="false" title="Product Order Sales"
                    @onClickCloseButton="navigateToListPage" />
            </div>
            <div class="so-body">
                <section class="so-section">
                    <div class="row g-2">
                        <div class="col-12 col-sm-6 col-lg-4">
                            <div class="d-flex align-items-start justify-content-between">
                                <label class="so-label">Customer Name <span class="text-danger">*</span></label>
                                <span class="so-search-icon" @click="onOpenContactSearchModal">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <AsyncSelect placeholder="Select Customer Name" v-model="contactProfile"
                                :api-service="fetchContactProfiles" :additional-query="additionalContactOption"
                                :format-label="formatPatientLabel"
                            />
                            <span v-if="!contactProfile && isFormSubmitted" class="so-error">Customer Name is required</span>
                        </div>
                        <div v-if="false" class="col-12 col-sm-6 col-lg-4">
                            <div class="d-flex align-items-start justify-content-between">
                                <label class="so-label">Sales Person</label>
                                <span class="so-search-icon" @click="onOpenContactSearchModal">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <AsyncSelect placeholder="Select Sales Person" v-model="salesProfile"
                                :api-service="fetchContactProfiles" :additional-query="additionalSalesOption"
                                :format-label="formatPatientLabel"
                            />
                        </div>
                        <div v-if="false" class="col-12 col-sm-6 col-lg-4">
                            <label class="so-label">Commission %</label>
                            <input class="form-control" type="number" placeholder="Please add commission %"
                                v-model="formData.commission_percent">
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4">
                            <label class="so-label">Date</label>
                            <input class="form-control" type="date" v-model="formData.date">
                        </div>
                        <div v-if="false" class="col-12 col-sm-6 col-lg-3">
                            <label class="so-label">Delivery Port</label>
                            <input class="form-control" type="text" placeholder="Please add delivery port"
                                v-model="formData.delivery_port">
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4">
                            <label class="so-label">Order Type</label>
                            <v-select
                                placeholder="Select Order Type"
                                v-model="formData.sale_type"
                                :options="orderTypes"
                                label="name"
                                :reduce="name => name.value"
                            />
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4">
                            <label class="so-label">Ship From (Warehouse) <span class="text-danger">*</span></label>
                            <v-select
                                placeholder="Select Warehouse Location"
                                v-model="formData.location_id"
                                :options="locations"
                                label="text"
                                :reduce="text => text.id"
                            />
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4">
                            <label class="so-label">Ship To</label>
                            <vField
                                as="textarea"
                                name="destination_address"
                                rows="1"
                                type="text"
                                class="form-control"
                                placeholder="Ship To"
                                v-model="formData.destination_address"
                            />
                        </div>
                    </div>
                </section>

                <section class="so-section">
                    <div class="so-product-form">
                        <ProductForm @handleProductAdd="handleProductAdd" :formData="formData" :tableItems="formData.item_details" :quick-add="true" ref="productForm" />
                    </div>
                    <div class="so-table mt-1">
                        <ProductsTable :itemDetails="formData.item_details" @removeBill="removeBill" :formRef="productForm" />
                    </div>
                    <div v-if="! hasItems" class="so-empty">
                        <i class="fa-solid fa-box-open so-empty-icon"></i>
                        <div class="so-empty-title">No products added yet</div>
                        <div class="so-empty-text">Select a product and quantity above, then press Add or Enter.</div>
                    </div>
                </section>

                <div class="row g-2">
                    <div class="col-12 col-lg-7">
                        <section class="so-section so-section--fill">
                            <vField as="textarea" name="description" rows="4" class="form-control"
                                placeholder="Write terms & condition" v-model="formData.description" />
                        </section>
                    </div>
                    <div class="col-12 col-lg-5">
                        <section class="so-section so-section--fill">
                            <div class="so-summary-row">
                                <span>Sub Total</span>
                                <span class="so-summary-value">{{ formatAmount(subTotal) }}</span>
                            </div>
                            <div class="so-summary-row">
                                <span>VAT</span>
                                <span class="so-summary-value">{{ formatAmount(totalVAT) }}</span>
                            </div>
                            <div class="so-summary-row">
                                <span>Total</span>
                                <span class="so-summary-value">{{ formatAmount(total) }}</span>
                            </div>
                            <div class="so-summary-adjust">
                                <label class="so-label">Discount / Round up Adj</label>
                                <div class="so-adjust-inputs">
                                    <div class="input-group so-adjust-percent">
                                        <input
                                            v-model.trim="discountPercent"
                                            type="number" class="form-control text-end"
                                            placeholder="0" :min="0"
                                        >
                                        <span class="input-group-text">%</span>
                                    </div>
                                    <input
                                        v-model.trim="discountAmount"
                                        type="number" class="form-control text-end"
                                        placeholder="Amount" :min="0"
                                    >
                                </div>
                            </div>
                            <div v-if="discountAmount > 0" class="so-summary-adjust">
                                <label class="so-label">Discount Head</label>
                                <v-select
                                    placeholder="Select Discount Head"
                                    v-model="formData.discount_head_id"
                                    :options="salesAccountHeads"
                                    label="name"
                                    :reduce="name => name.id"
                                />
                            </div>
                            <div class="so-summary-net">
                                <span>Net Bill</span>
                                <span>{{ formatAmount(grandTotal) }}</span>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="so-footer">
                <button :disabled="productLoader" @click="navigateToListPage"
                    class="btn btn-outline-secondary">Cancel</button>
                <template v-if="! route.params.salesId">
                    <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(false, false)"
                        class="btn btn-outline-primary">Save &amp; New</button>
                    <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true, false)"
                        class="btn btn-outline-primary">Save</button>
                    <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true, true)"
                        class="btn btn-primary">
                        <i class="fa-solid fa-print"></i>
                        Save &amp; Print
                    </button>
                </template>
                <button v-else :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true, false)"
                    class="btn btn-primary">Update</button>
            </div>
        </div>
        <GlobalLoader />
        <ContactDropdownFilter v-if="store.state.isModalOpenThree" @onSearchContact="onSearchContact" type="supplier"
            :companyRoles="companyRoles" />
    </div>
</template>

<script setup>
import {computed, inject, onMounted, provide, ref, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleInventory from '@/services/modules/inventory'
import handleCBusinesses from '@/services/modules/businesses'
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleContact from '@/services/modules/contact'
import TitleButton from '@/components/atom/TitleButton'

import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import { useAsyncDropdownHelper } from "@/services/utils/asyncDropdownHelper";
import { useStore } from "vuex";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handleRole from "@/services/modules/role";
import ProductForm from "./ProductForm.vue"
import ProductsTable from "./ProductsTable.vue"
import useDate from '@/services/utils/day'
import handleBarcode from "@/services/modules/barcode";
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleCompany from "@/services/modules/company";
import figureFormatter from "@/services/utils/figureFormatter";
import { editVoucherNumber } from "../../../../../../services/utils/voucherNumberGenerator";

const router = useRouter()
const route = useRoute()
const store = useStore()

const showError = inject('showError');
const showSuccess = inject('showSuccess');

const { fetchAccountHead, ...rest } = handlePurchase()
const { fetchCountryOfOrigins } = handleInventory()
const { fetchBusinessList } = handleCBusinesses()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const { fetchContactProfiles } = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchBarcode } = handleBarcode();
const { formatDate, currentDate } = useDate()
const { exportToPDF } = pdfPrinter();
const { fetchCompanyInfo } = handleCompany();
const { commaFormat } = figureFormatter();
const isFormSubmitted = ref(false);
const companyId = computed(() => {
    return route.params.companyId
})
const additionalContactOption = ref({
    with_mobile: 1,
    with_donors: 1,
    dealer_id: '',
    roles: 'customer,lead'
});
const additionalBuyerOption = ref({
    with_mobile: 1,
    with_donors: 1,
    dealer_id: '',
    roles: 'buyer'
});
const additionalSalesOption = ref({
    with_mobile: 1,
    with_donors: 1,
    dealer_id: '',
    roles: 'sales_representative'
});
const loader = ref(false)
const productLoader = ref(false)
const saveButtonLoader = ref(false)
const saveNewButtonLoader = ref(false)
const accountHeads = ref([])
const business = ref([])
const locations = ref([])
const salesAccountHeads = ref([])
const accountPayable = ref([])
const vatPayable = ref([])
const discountPercent = ref(null);
const discountAmount = ref(null);
const companyInfo = ref({});
const contactProfile = ref(null);
const buyerProfile = ref(null);
const salesProfile = ref(null);
const productForm = ref(null);
const companyRoles = ref([]);
const orderTypes = ref([])
const grandTotal = ref(0);
const formData = ref({
    company_id: companyId,
    contact_profile_id: null,
    buyer_id: null,
    sales_person_id: null,
    account_head_id: null,
    business_id: null,
    location_id: null,
    currency: null,
    bill_number: '',
    status: 'active',
    date: '',
    has_item_detail: true,
    description: '',
    account_details: [],
    item_details: [],
    discount_amount: 0,
    loading_port: '',
    delivery_port: '',
    destination_address: '',
    country_of_origin: null,
    sale_type: '',
    adjustment_amount: null,
    route_name:'product-sales-order',
})
provide('formData', formData);

const countries = ref([])

onMounted(async () => {
    loader.value = true
    formData.value.date = currentDate();
    const companyQuery = `?company_id=${companyId.value}`

    const getCountryOfOrigins = fetchCountryOfOrigins(companyQuery)

    const accountHeadRes = fetchAccountHead(companyQuery)
    const businessRes = fetchBusinessList(companyQuery)
    const businessLocationRes = fetchBusinessLocationsList(companyQuery)
    const payableRes = rest.fetchAccountReceivable(companyQuery)
    const vatPayableRes = rest.fetchVatPayable(companyQuery)
    const fetchSalesOrderTypes = rest.fetchSalesOrderTypes(companyQuery)
    const salesAccountHeadsRes = rest.getAccountHeadBySlag("sales_accounts", companyQuery)
    Promise.all([
        accountHeadRes.then(res => {
            if (res.data) accountHeads.value = res.data
        }),
        fetchSalesOrderTypes.then(res => {
          if(res.data) {
            orderTypes.value = res.data
            formData.value.sale_type = res.data[0].value;
          }
        }),
        businessRes.then(res => {
            if (res.data) business.value = res.data
        }),
        businessLocationRes.then(res => {
            if (res.data) locations.value = res.data
        }),
        fetchCompanyDefaultRoles(companyQuery).then(res => {
            if (res.data) companyRoles.value = res.data
        }),
        payableRes.then(res => {
            if (res.data) {
                accountPayable.value = res.data
            }
            if (res.data && res.data.length) {
                formData.value.account_head_id = res.data[0].id
            }
        }),
        vatPayableRes.then(res=> {
          if(res.data) vatPayable.value = res.data
          if(res.data && res.data.length) {
            formData.value.vat_payable_account_head_id = res.data[0].id
          }
        }),
        salesAccountHeadsRes.then(res => {
            if (res.data) salesAccountHeads.value = res.data
            formData.value.discount_head_id = res.data[0] ? res.data[0].id : null
        }),
        fetchCompanyInfo(companyId.value).then(res => {
            if (res) {
                companyInfo.value = res.data
            }
        }),
        getCountryOfOrigins.then(res => {
            countries.value = res.data
        }),
        await getSingleSalesOrder()
    ])
        .then(() => { loader.value = false })
        .catch(() => { loader.value = false })
})

const getSingleSalesOrder = async () => {
  const salesId = route.params.salesId;

  if (! salesId) {
    return;
  }

  const companyQuery = `?company_id=${companyId.value}`;

  productLoader.value = true;
  try {
  let res = await rest.fetchSalesOrderById(salesId, companyQuery);
    if (! res.status) {
      return showError('Something went wrong');
    }
    formData.value = res.data
    if(res.data.has_item_detail) {
      formData.value.item_details = res.data.general && res.data.general.map(item => ({
        ...item,
        product_name: item.product ? item.product.name : '',
        show_item: true
      })) || [];
      formData.value.has_item_detail = true
    }

    if(res.data.contact){
        contactProfile.value = res.data.contact
    }

    if(res.data.sales_person){
      salePersons.value = res.data.sales_person
    }

    if(res.data.adjustment_amount) {
      discountAmount.value = res.data.adjustment_amount;
      formData.value.discount_head_id = res.data.discount_head_id;
    }

    productLoader.value = false;
  } catch (err) {
    productLoader.value = false;
  }
}

const isItem = computed(() => {
    return formData.value.has_item_detail
})

const itemCount = computed(() => {
    if (! Array.isArray(formData.value.item_details)) return 0
    return formData.value.item_details.length
})

const hasItems = computed(() => itemCount.value > 0)

const formatAmount = (value) => commaFormat(Number(value || 0).toFixed(2))

const subTotal = computed(() => {
    let subTotal = 0
    if (formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
            subTotal += parseFloat((item.quantity * item.rate) - (item.discount_amount + item.offer_discount))
        })
    }
    if (!formData.value.has_item_detail) {
        formData.value.account_details.map(item => {
            if (item.amount) { subTotal += parseFloat(item.amount) }
        })
    }

    return subTotal.toFixed(2)
})

const totalVAT = computed(() => {
    let vat = 0
    if (formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
            if (item.vat_amount) {
                vat += parseFloat(item.vat_amount)
            }
        })
    }
    if (!formData.value.has_item_detail) {
        formData.value.account_details.map(item => {
            if (item.vat_amount) {
                vat += parseFloat(item.vat_amount)
            }
        })
    }

    return vat.toFixed(2)
})

const total = computed(() => {
    return parseFloat(subTotal.value) + parseFloat(totalVAT.value)
})

watch(discountAmount, () => {
  grandTotal.value = total.value - discountAmount.value
  formData.value.adjustment_amount = discountAmount.value
  grandTotal.value = total.value - discountAmount.value
})

watch(discountPercent, () => {
  if(discountPercent.value === 0){
    return discountAmount.value = 0;
  }
  return discountAmount.value = (total.value * discountPercent.value) / 100;
})

watch(total, () => {
  grandTotal.value = total.value - discountAmount.value;
})

watch(contactProfile, (newVal) => {
    if (!newVal) {
        formData.value.contact_profile_id = null;
        return;
    }

    formData.value.contact_profile_id = newVal.id;
})

watch(buyerProfile, (newVal) => {
    if (!newVal) {
        formData.value.buyer_id = null;
        return;
    }

    formData.value.buyer_id = newVal.id;
})

watch(salesProfile, (newVal) => {
    if (!newVal) {
        formData.value.sales_person_id = null;
        return;
    }

    formData.value.sales_person_id = newVal.id;
})

function navigateToListPage() {
    let routeName = 'order-sales'
    if (route.query.type === 'order_production_tracker') {
        routeName = 'order-production-tracker'
    }
    router.push({ name: routeName, params: route.params, query: route.query })
}

function onOpenContactSearchModal() {
    store.state.isModalOpenThree = true;
}

function onSearchContact(contact) {
    contactProfile.value = contact
}

function removeBill(index) {
    formData.value.item_details.splice(index, 1)
}

const goToPrint = (id) => {
    const user = store.state.user.user
    const companyQuery = `?company_id=${route.params.companyId}`;
    let barcodeQuery = "";
    let qrcode = null
    let barcode = null
    let singleSalesOrder = null

    rest.fetchSalesOrderById(id, companyQuery).then((res) => {
        if (res) {
            singleSalesOrder = res.data;
            let qrcodeData = JSON.stringify({
                ref_no: singleSalesOrder.bill_number,
                ref_date: singleSalesOrder.date,
                created_by: user.name,
                created_date_time: formatDate(new Date())
            })
            barcodeQuery = `?code=${singleSalesOrder.bill_number}&qrcode=${qrcodeData}`;
        }
    }).then(() => {
        fetchBarcode(barcodeQuery).then((res) => {
            barcode = res.barcode;
            qrcode = res.qrcode
        }).then(() => {
            exportToPDF(companyInfo.value, singleSalesOrder, barcode, qrcode, user.name, 1,[],true)
        })
    }).catch(() => {
        showError('Something went wrong')
    })
}

async function handleSubmit(redirect = false, print = false) {
    isFormSubmitted.value = true;
    if (!contactProfile.value) {
        return;
    }
    if (!formData.value.item_details.length) {
        return showError('Please add product')
    }
    if (!formData.value.location_id){
        return showError('Please select warehouse location')
    }

    saveNewButtonLoader.value = true

    if (!formData.value.date) formData.value.date = currentDate();

    if (!formData.value.adjustment_amount) {
        formData.value.discount_head_id = null;
    }

    let copyFormData = Object.assign({}, formData.value);
    copyFormData.has_item_detail = formData.value.has_item_detail ? 1 : 0
    copyFormData.updateSalePrice = 1;
    if (isItem.value) {
        delete copyFormData.account_details
        copyFormData.item_details = formData.value.item_details
    } else {
        delete copyFormData.item_details
        copyFormData.account_details = formData.value.account_details
    }

    try {
      let res = route.params.salesId ? await rest.updateSalesOrder(route.params.salesId,  copyFormData) : await rest.createSalesOrder(copyFormData)
      saveButtonLoader.value = false
      saveNewButtonLoader.value = false

      if (!res.status) {
        return showError(res.message)
      }

      showSuccess(res.message)
      await resetForm()
      if (print && res.data.id) await goToPrint(res.data.id)
      if (redirect) navigateToListPage()

    } catch (err) {
      saveButtonLoader.value = false
      saveNewButtonLoader.value = false
      productLoader.value = false

      if (!err.response) {
        showError('Something is wrong. Check your connectivity!!')
        return;
      }

      if (err.response.status === 406 || ! err.response.data) {
        return;
      }

      showError(err.response.data.message)
    }
  }

// have to refactor
async function resetForm() {
    formData.value.item_details = []
    formData.value.description = '';
    formData.value.destination_address = '';
    contactProfile.value = null;
    discountAmount.value = null;
}

const handleProductAdd = (item, index) => {
    if (index !== null && Array.isArray(formData.value.item_details) && !!formData.value.item_details[index]) {
        formData.value.item_details[index] = item;
        return;
    }

    formData.value.item_details.push(item);
}

</script>

<style scoped>
.so-card {
    margin-bottom: 0;
    border: none;
    border-radius: 14px;
    box-shadow: 0 6px 24px rgba(34, 41, 47, 0.08);
    overflow: hidden;
}
.so-header {
    background: linear-gradient(135deg, #eef4ff 0%, #f6f9ff 100%);
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e6ebf5;
}
.so-body {
    padding: 0.75rem;
    background: #fbfcfe;
}
.so-section {
    background: #fff;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    padding: 0.75rem;
    margin-bottom: 0.75rem;
}
.so-section--fill {
    height: 100%;
    margin-bottom: 0;
}
.so-label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: #000;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}
.so-search-icon {
    font-size: 0.8rem;
    color: #000;
    cursor: pointer;
}
.so-search-icon:hover {
    color: #5a8dee;
}
.so-error {
    display: block;
    font-size: 0.78rem;
    color: #ea5455;
}
.so-body :deep(.form-control) {
    border-radius: 8px;
}
.so-body :deep(.v-select .vs__dropdown-toggle) {
    border-radius: 8px;
}
.so-product-form :deep(.product-details-border) {
    border: none;
    padding: 0;
}
.so-product-form :deep(.row) {
    align-items: flex-end;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
}
.so-product-form :deep(.row > [class*="col-"]) {
    padding-left: 0;
    padding-right: 0;
}
.so-product-form :deep(.mt-2) {
    margin-top: 0 !important;
}
.so-product-form :deep(.form-label) {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: #000;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}
.so-product-form :deep(.btn) {
    border-radius: 8px;
}
.so-table :deep(.table-responsive) {
    margin-bottom: 0 !important;
    border: 1px solid #eef1f6;
    border-radius: 10px;
}
.so-table :deep(.table) {
    margin-bottom: 0;
}
.so-table :deep(.table-bordered > :not(caption) > *) {
    border-width: 0;
}
.so-table :deep(.table thead th) {
    background: #f6f8fc;
    color: #000;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    border-color: #eef1f6;
    white-space: nowrap;
}
.so-table :deep(.table td) {
    border-color: #eef1f6;
    vertical-align: middle;
}
.so-table :deep(.table tbody tr) {
    cursor: pointer;
}
.so-table :deep(.table tbody tr:hover) {
    background: #fafbff;
}
.so-empty {
    padding-top: 0.75rem;
    text-align: center;
    color: #000;
}
.so-empty-icon {
    font-size: 1.4rem;
    color: #c7cbd4;
}
.so-empty-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #000;
}
.so-empty-text {
    font-size: 0.8rem;
}
.so-summary-row {
    display: flex;
    justify-content: space-between;
    padding: 0.35rem 0;
    border-bottom: 1px solid #f0f2f6;
    color: #000;
    font-weight: 500;
}
.so-summary-value {
    color: #000;
    font-weight: 600;
}
.so-summary-adjust {
    padding-top: 0.5rem;
}
.so-adjust-inputs {
    display: flex;
    gap: 0.5rem;
}
.so-adjust-percent {
    flex: 0 0 120px;
}
.so-adjust-percent .form-control {
    border-radius: 8px 0 0 8px;
}
.so-adjust-percent .input-group-text {
    border-radius: 0 8px 8px 0;
}
.so-summary-net {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 10px;
    background: #eef4ff;
    color: #000;
    font-size: 1.05rem;
    font-weight: 700;
}
.so-footer {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.75rem;
    border-top: 1px solid #e6ebf5;
    background: #fff;
}
.so-footer .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 96px;
    justify-content: center;
    border-radius: 8px;
}
@media (min-width: 768px) {
    .so-product-form :deep(.row > [class*="col-"]:not(:last-child)) {
        padding-right: 0.75rem;
    }
}
@media (max-width: 767.98px) {
    .so-product-form :deep(.row > [class*="col-"] + [class*="col-"]) {
        margin-top: 0.5rem;
    }
}
@media (max-width: 576px) {
    .so-header :deep(.h1) {
        font-size: 1.35rem;
    }
    .so-footer .btn {
        flex: 1 1 45%;
    }
}
</style>
